"use client";
// @ts-strict-ignore
import styled from "styled-components";

export const HeroBackgroundImage1 = styled.img`
  content: ${({ desktopSrc }) => `url(${desktopSrc})`};
  display: flex;
  height: auto;
  max-height: 800px;
  min-height: 500px;
  object-fit: fill;
  overflow: hidden;
  position: relative;
  width: 100%;

  @media (max-width: 850px) {
    content: ${({ mobileSrc }) => `url(${mobileSrc})`};
    max-height: 750px;
    min-height: 650px;
  }
`;

export const HeroBackgroundImage2 = styled.img`
  bottom: 85px;
  content: ${({ src }) => `url(${src})`};
  display: flex;
  height: calc(100% - 170px);
  left: 54%;
  overflow: hidden;
  position: absolute;
  top: 85px;
  width: auto;

  @media (max-width: 1440px) {
    left: unset;
    right: 85px;
  }

  @media (max-width: 850px) {
    bottom: 7.5%;
    height: 360px;
    left: 50%;
    right: unset;
    top: unset;
    transform: translateX(-50%);
  }

  @media (max-width: 435px) {
    height: 47.5%;
  }

  @media (max-width: 400px) {
    height: 44%;
  }

  @media (max-width: 320px) {
    height: auto;
    width: 70%;
  }
`;

export const HeroBackgroundImage3 = styled.img`
  bottom: -2.5px;
  content: ${({ desktopSrc }) => `url(${desktopSrc})`};
  display: flex;
  height: auto;
  inset: 0;
  max-height: 800px;
  min-height: 500px;
  object-fit: fill;
  overflow: hidden;
  position: absolute;
  width: 100%;

  @media (max-width: 850px) {
    content: ${({ mobileSrc }) => `url(${mobileSrc})`};
    max-height: 750px;
    min-height: 650px;
  }
`;
